const reminderStatus = {
    INCOMPLETE : 0,

    COMPLETE : 1,

    PASTDUE : 2

};

angular.module('gw-um-j2js')
    .constant('reminderStatus', reminderStatus);